/* eslint-disable max-lines-per-function */
import React from "react";
import { useQuery } from "@apollo/client";
import { CircularProgress, Chip, Grid, makeStyles } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import {
  SlideoutApplications as Query,
  SlideoutApplicationsVariables as QueryVars,
  SlideoutApplications_otherInterests as Interest,
} from "types/gql-types";
import { Viewer } from "components/auth/types";
import { Timestamp } from "components/timestamp";
import { CopyButton } from "components/haven-design/copy-button";
import { query } from "./queries";
import { applicationsPageStyles } from "./styles";


const useStyles = makeStyles(applicationsPageStyles);

type Props = { interestId: string; viewer: Viewer };

const ApplicationsPage: React.FC<RouteComponentProps & Props> = ({ interestId, viewer }) => {
  const classes = useStyles();

  const { data, loading, error } = useQuery<Query, QueryVars>(query, {
    fetchPolicy: "network-only",
    variables: { interestId },
  });

  if (loading) return <CircularProgress />;
  if (error) return <div>Error loading data</div>;
  const viewerListIds = viewer.lists?.map((list) => list.id) || [];

  const getApplicationsLink = (app: Interest) =>
    `/dash/manager/lists/${app.interestListId}/p/1/interests/${app.id}/applications`;
  return (
    <Grid container>
      {data?.otherInterests?.map((app) => {
        const authorizedToUseLink = viewerListIds.includes(app.interestListId);
        const showWaitlistLink = app.updateRequest?.isActive;
        const waitlistLink = app.updateRequest?.updateUrl ?? "";

        return (
          <Grid container item key={app.id} className={classes.row}>
            <Grid item xs={12} className={classes.header}>
              {authorizedToUseLink ? (
                <a
                  href={getApplicationsLink(app)}
                  target="_blank"
                  rel="noreferrer"
                >
                  {app.firstName} {app.lastName} - {app.interestListName}
                </a>
              ) : (
                <span className={classes.disabled}>
                  {app.firstName} {app.lastName} - {app.interestListName}
                </span>
              )}
              {app.id === interestId && (
                <Chip
                  label="current application"
                  color="primary"
                  size="small"
                  variant="outlined"
                  className={classes.chip}
                />
              )}
            </Grid>
            <Grid item md={showWaitlistLink ? 6 : 12} className={classes.secondary}>
              <b>Applied:</b> &nbsp;
              <Timestamp date={new Date(app.submittedAt * 1000)} showDate /> &nbsp;
              <b>Status:</b> {app.status} <br />
              <b>Household Count:</b> {app.householdCount} &nbsp;
              <b>Household Gross Annual Income:</b> $
              {app?.householdGrossAnnualIncome?.toLocaleString()}
            </Grid>
            {showWaitlistLink && (
              <Grid container item md={6} className={classes.secondary}>
                <Grid item>
                  <CopyButton text={waitlistLink} size="small" withLabel className={classes.copyButton} />
                </Grid>
                <Grid item>
                  <b>Waitlist Update Link:</b><br />
                  <a href={waitlistLink} target="_blank" rel="noreferrer">{waitlistLink}</a>
                </Grid>
              </Grid>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ApplicationsPage;
